import styled from 'styled-components';
import {injectAdaptive} from 'ui/theme';

export const Wrapper = styled.header`
  padding: 25px 0;
  ${injectAdaptive('padding-bottom', ['15px', '15px', '20px', '25px', '25px'])}
`;

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;
